import { Button, Label, Modal, TextInput, useValidatedState, ValidationHint } from 'acma-spa';
import React, { useEffect, useState } from 'react';
import { getApiClient } from '../api';
import * as yup from 'yup';
import { PublicClientApplication } from '@azure/msal-browser';

export interface HelpModalProps {
  open: boolean;
  onClose: (validated: boolean) => any;
  title: string;
}

export const HelpModal: React.FC<HelpModalProps> = (props) => {
 
  return (
    <>
      {props.open ? (
        <Modal
          id="helpModal"
          open={true}
          onClose={() => props.onClose(false)}
          title={props.title}
          leftButtons={[
            {
              label: 'Cancel',
              onClick: () => props.onClose(false),
              mode: 'secondary',
            },
          ]}
          backdrop={'static'} 
          keyboard={false}
        >
          <div id="helpContainer">
            <p>If the amateur operator you want to transfer this call sign to does not have a client number, they must first contact the ACMA at <a href="mailto:info@acma.gov.au">info@acma.gov.au</a> to confirm that the ACMA has a record of their amateur radio qualification, prior to submitting this application.</p>
          </div>
        </Modal>
      ) : (
        <></>
      )}
    </>
  );
};
